import React, { useEffect, useState } from "react";
import { Loader, Pagination, Table } from "semantic-ui-react";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { local, producaov2 as api } from "../../../../services/apis";
import { Container, Content, Center, Link, Header } from "./styled";
import { datePattern, formatValue } from "../../../../utils/Utils";
import Status from "../../../../components/Admin/Pagarme/Status";
import { AlunoSearchInput } from "../../../../components/Admin/AlunoSearchInput";
import { Button } from "../../../../components";
import ActionButton from "../../NovoEmpresas/components/ActionButton";
import swal from "sweetalert";
import useConfigKey from "../../../../hooks/useConfigKey";

const PagarmeAssinantes = () => {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  // const [status, setStatus] = useState('')
  const [subscriptions, setSubscriptions] = useState([]);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedAluno, setSelectedAluno] = useState();
  const [searchKey, setSearchKey] = useState(0);

  useEffect(() => {
    setLoading(true);
    api
      .get("/pagarme/assinantes", { params: { page, total_items: 15 } })
      .then((res) => {
        setSubscriptions(res.data.itens);
        setTotal(res.data.totalItens);
        setTotalPages(res.data.totalPages);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  }, [page]);

  const onSubmit = () => {
    setLoading(true);
    api
      .get("/pagarme/assinantes", {
        params: { page, total_items: 10, ref: selectedAluno },
      })
      .then((res) => {
        setSubscriptions(res.data.itens);
        setTotal(res.data.totalItens);
        setTotalPages(res.data.totalPages);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  const onClearSearch = () => {
    setLoading(true);
    setSelectedAluno(undefined);
    setSearchKey((prev) => prev + 1);
    api
      .get("/pagarme/assinantes", {
        params: { page, total_items: 10 },
      })
      .then((res) => {
        setSubscriptions(res.data.itens);
        setTotal(res.data.totalItens);
        setTotalPages(res.data.totalPages);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  const config_key = useConfigKey({
    key: "enable-subscriptions-pending-button",
    fallbackValue: false,
  });

  const onRetryCharge = async () => {
    swal({
      title: "Tem certeza que deseja realizar a retentativa de cobrança?",
      icon: "warning",
      buttons: {
        cancel: {
          text: "Cancelar",
          value: false,
          visible: true,
          closeModal: true,
        },
        confirm: {
          text: "Sim",
          value: true,
          visible: true,
          closeModal: true,
        },
      },
    }).then((willRetry) => {
      if (willRetry) {
        api
          .post("/admin/script/execute/subscriptions-pending", {
            is_triggered: true,
          })
          .then(() => {
            console.log("Retentativa de cobrança iniciada");
          })
          .catch((err) => {
            swal(
              "Falha na Retentativa de cobrança!",
              err?.response?.data?.message ||
                "A proxima retentativa só poderá ser feita daqui a 24 horas.",
              "error"
            );
            console.error(err);
          });
        swal(
          "Retentativa de cobrança realizada!",
          "A próxima retentativa só poderá ser feita daqui a 24 horas.",
          "success"
        );
      }
    });
  };

  return (
    <div style={{ width: "100vw", paddingLeft: "250px" }}>
      <AdminMenu />
      <Container>
        <Content>
          <Header>
            <div>
              <h1>Assinantes Pagarme</h1>
              <p>Total de assinaturas: {total}</p>
            </div>
            <div
              style={{ display: "flex", gap: "1rem", flexDirection: "column" }}
            >
              <a href="/admin/pagarme/inadimplentes">Alunos inadimplentes</a>
              {config_key.value && (
                <ActionButton
                  onClick={() => onRetryCharge()}
                  text={"RETENTATIVA DE COBRANÇA"}
                  style={{
                    height: "auto",
                    justifyContent: "center",
                    backgroundColor: "#FF0000",
                    color: "#fff",
                    fontWeight: "600",
                  }}
                />
              )}
            </div>
          </Header>
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              gap: "0.5rem",
              flexDirection: "column",
            }}
          >
            <AlunoSearchInput
              key={searchKey}
              handleChange={(evt) => {
                setSelectedAluno(evt.id);
              }}
            />
            <div
              style={{ display: "flex", flexDirection: "row", gap: "0.5rem" }}
            >
              <ActionButton
                onClick={() => onSubmit()}
                text={"buscar"}
                style={{
                  height: "38px",
                }}
              />
              {selectedAluno && (
                <ActionButton
                  onClick={() => onClearSearch()}
                  text={"Limpar Busca"}
                  style={{
                    height: "38px",
                  }}
                />
              )}
            </div>
          </div>

          <Table stackable>
            <Table.Header>
              <Table.HeaderCell>
                <Center>Id pedido</Center>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>Id assinatura</Center>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>Aluno</Center>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>Valor</Center>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>Status Assinatura</Center>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>Parcelas</Center>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>Data assinatura</Center>
              </Table.HeaderCell>
              {/* <Table.HeaderCell>
                <Center>Data próxima cobrança</Center>
              </Table.HeaderCell> */}
              <Table.HeaderCell>
                <Center>Ação</Center>
              </Table.HeaderCell>
            </Table.Header>

            <Table.Body>
              {loading ? (
                <Loader active={loading} />
              ) : subscriptions.length !== 0 ? (
                subscriptions.map((sub) => (
                  <Table.Row>
                    <Table.Cell>
                      <Center>{sub.id_pedido}</Center>
                    </Table.Cell>
                    <Table.Cell>
                      <Center>{sub?.subscribe || "00 0000"}</Center>
                    </Table.Cell>
                    <Table.Cell>
                      <Center>
                        [{sub.id_pessoa}]: {sub.name}{" "}
                      </Center>
                    </Table.Cell>
                    <Table.Cell>
                      <Center>
                        {sub.totalCycle
                          ? `${sub.totalCycle}x ${formatValue(
                              sub.fature.amount
                            )}`
                          : `infinitas/${sub.plan.interval}`}
                      </Center>
                    </Table.Cell>
                    <Table.Cell>
                      <Center>
                        <Status status={sub.status} />
                      </Center>
                    </Table.Cell>
                    <Table.Cell>
                      <Center>
                        {sub.cycle.includes("undefined")
                          ? `${sub.cycle.replace("/undefined", "")}/infinitas`
                          : sub.cycle}
                      </Center>
                    </Table.Cell>
                    <Table.Cell>
                      <Center>{datePattern(sub.created_at)}</Center>
                    </Table.Cell>
                    {/* <Table.Cell>
                      <Center>{datePattern(sub.nextBilling)}</Center>
                    </Table.Cell> */}
                    <Table.Cell>
                      <Center>
                        <Link
                          href={`/admin/pagarme/assinante/${sub.id_pessoa}?id_assinatura=${sub?.subscribe}`}
                          target="_blank"
                        >
                          Abrir
                        </Link>
                      </Center>
                    </Table.Cell>
                  </Table.Row>
                ))
              ) : (
                <Table.Footer>
                  <Table.Row>
                    <Table.HeaderCell colSpan="7">
                      <p>Nenhuma assinante encontrado</p>
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Footer>
              )}
            </Table.Body>
          </Table>
          {!loading && (
            <Pagination
              boundaryRange={0}
              activePage={page}
              defaultActivePage={1}
              onPageChange={(e, f) => setPage(f.activePage)}
              firstItem={null}
              lastItem={null}
              totalPages={totalPages}
            />
          )}
        </Content>
      </Container>
    </div>
  );
};

export default PagarmeAssinantes;
